export default "__VITE_ASSET__C08C5pO2__"